import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function ToolTip({ text, id, place = "top" }) {
  return (
    <ReactTooltip id={id} place={place} effect="solid">
      {text}
    </ReactTooltip>
  );
}
